import { render } from "./BoardCorner.vue?vue&type=template&id=f562839e&ts=true"
import script from "./BoardCorner.vue?vue&type=script&lang=ts"
export * from "./BoardCorner.vue?vue&type=script&lang=ts"

import "./BoardCorner.vue?vue&type=style&index=0&id=f562839e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__